/**
 * TanStack Query hooks for `dashboard-export-png-pdf`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	dashboardExportPngPdfQueryKeys,
	type CreateDashboardExportPngPdfBody,
	type ListDashboardExportPngPdfResponse,
	type DashboardExportPngPdfRow,
} from "./api";

export function useDashboardExportPngPdfList(): UseQueryResult<ListDashboardExportPngPdfResponse, Error> {
	return useQuery({
		queryKey: dashboardExportPngPdfQueryKeys.list(),
		queryFn: list,
	});
}

export function useDashboardExportPngPdfCreate(): UseMutationResult<DashboardExportPngPdfRow, Error, CreateDashboardExportPngPdfBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dashboardExportPngPdfQueryKeys.all });
		},
	});
}

export function useDashboardExportPngPdfDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dashboardExportPngPdfQueryKeys.all });
		},
	});
}
